import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    opacity: 0;
    
    &.z-index-top {
        z-index: 1000000;
    }

    animation: fadeInModal 300ms linear forwards;

    @keyframes fadeInModal {
        100% {
            opacity: 1;
        }
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        z-index: 98;
    }

    .modal-container-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 90%;
        max-width: 1360px;
        background-color: white;
        border-radius: .5em;
        box-shadow: 0 0.4em 1em rgba(0, 0, 0, .05);
        z-index: 99;
        transform: translate(-50%, -50%);

        .modal-close-button {
            position: absolute;
            top: 1em;
            right: 18px;
            color: #111111;
            cursor: pointer;
            z-index: 11;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 26px;
            height: 26px;
            border-radius: 26px;
            background-color: #ffffff;
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);

            .icon {
                background-image: url(/theme/images/x.svg);
                width: 1.4em;
                height: 1.4em;
                background-size: cover;
                background-repeat: no-repeat;
                border: 1px solid transparent;
                border-radius: 1.4em;
            }

            &:hover {
                box-shadow: 0 0 4px #ba9449;

                .icon {
                    background-image: url(/theme/images/x-gold.svg);
                }
            }
        }

        .modal-container {
            overflow-x: hidden;
            overflow-y: auto;
            width: 100%;
            max-height: 85vh;

            &::-webkit-scrollbar-track {
                border-radius: 10px;
                background-color: #ffefdf;
                box-shadow: inset 0 0 5px 0 rgb(0 0 0 / 20%);
            }

            &::-webkit-scrollbar {
                width: 10px;
                height: 9px;
                box-shadow: inset 0 0 5px 0 rgb(0 0 0 / 20%);
                border-radius: 10px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background-color: #ba9449;
            }

            .modal-header {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                position: relative;

                .modal-header-title {
                    font-weight: 300;
                    font-size: 2em;
                    color: #666666;
                }
            }

            .modal-body {
                padding: 3em;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        .modal-container-wrapper {
            .modal-close-button {
                top: 10px;
                right: 14px;
            }

            .modal-container {
                .modal-body {
                    padding: 2em;
                }
            }
        }
    }
`;
